import { type HTMLTagsListElement, TagsListUpdatedEvent } from "@modules/bookmarks/advert-page/bookmark-tags"
import { makeTagsListItem } from "@modules/bookmarks/tags/tags-list-item"

let tagsPanelElement: HTMLElement | null = null

const tagsPanel = (): HTMLElement | null => {
    tagsPanelElement ??= document.querySelector<HTMLElement>(
        ".contacts-info-container .contacts-info-tags-box, .contacts-data .contacts-info-tags-box",
    )

    return tagsPanelElement
}

const openTagsButton = (root: HTMLElement): HTMLElement | null =>
    root.querySelector<HTMLElement>(".button-contacts-info-tags")

let currentDomUpdateRAF: number | null = null
function updateTagsPanel(tagsListElement: HTMLTagsListElement): void {
    if (currentDomUpdateRAF !== null) {
        cancelAnimationFrame(currentDomUpdateRAF)
        currentDomUpdateRAF = null
    }

    currentDomUpdateRAF = requestAnimationFrame((): void => {
        const tags: HTMLDivElement[] = []
        const tagsPanelElement: HTMLElement | null = tagsPanel()
        const tagsListContainerElement: HTMLElement | null =
            tagsPanelElement?.querySelector<HTMLElement>(".tags-box-list") ?? null

        if (tagsPanelElement === null || tagsListContainerElement === null) {
            return
        }

        for (const tag of tagsListElement.tagsList) {
            tags.push(makeTagsListItem(tag.tagName, tag.tagSlug))
        }

        tagsListContainerElement.textContent = ""
        tagsListContainerElement.append(...tags)

        checkTagListOverflow(tagsPanelElement, tagsListContainerElement)
    })
}

function checkTagListOverflow(tagsPanelElement: HTMLElement, tagsListContainerElement: HTMLElement): void {
    const openTagButtonElement: HTMLElement | null = openTagsButton(tagsPanelElement)

    if (openTagButtonElement === null) {
        return
    }

    if (tagsPanelElement.offsetHeight < tagsListContainerElement.offsetHeight) {
        openTagButtonElement.classList.remove("hidden")
    } else {
        openTagButtonElement.classList.add("hidden")
    }
}

export const initializeTagsPanel = (): void => {
    import("./tags-panel.css")

    const tagsListElement = document.body as HTMLTagsListElement
    const tagsPanelElement: HTMLElement | null = tagsPanel()

    if (tagsPanelElement === null) {
        return
    }

    tagsListElement.addEventListener(TagsListUpdatedEvent, (): void => updateTagsPanel(tagsListElement), {
        passive: true,
    })
    tagsPanelElement.classList.remove("hidden")

    openTagsButton(tagsPanelElement)?.addEventListener(
        "click",
        (): void => {
            tagsPanelElement.classList.toggle("open")
        },
        { passive: true },
    )

    updateTagsPanel(tagsListElement)
}
